module.exports = __webpack_public_path__ + "static/media/logo.99cc78a3.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/logo.png
 ** module id = 594
 ** module chunks = 0
 **/